<template>
  <div :style="props.appointment.normalStyle" class="card" @click="onClick">
    <div class="card__title">{{ title }}</div>
    <div class="card__info">
      <p>{{ formattedTime }}</p>
      <CustomerFlags :items="loadedCustomer?.tags || []" :mini="true" class="card__flags" />
    </div>
  </div>
</template>

<script setup>
import { format } from 'date-fns'
import { computed, watch, ref } from 'vue'

import { useCustomer } from '@/composables/useCustomer.js'
import { useAppointmentsStore } from '@/stores/appointments'

import CustomerFlags from '@/components/shared/CustomerFlags/CustomerFlags.vue'

const props = defineProps({
  appointment: {
    type: Object,
    default() {
      return {}
    }
  }
})

const { loadCustomerByEmail } = useCustomer()
const appointmentsStore = useAppointmentsStore()

const formattedTime = computed(() => {
  if (!props.appointment.start) {
    return ''
  }
  return [format(props.appointment.start, 'HH:mm'), format(props.appointment.end, 'HH:mm')]
    .filter(Boolean)
    .join(' – ')
})

const title = computed(() => {
  return [...(props.appointment.viuTitle || [])].reverse().join(' ')
})

function onClick() {
  appointmentsStore.selectedAppointmentId = props.appointment.id
}

const customer = computed(() => {
  return props.appointment?.singleCustomers?.[0]
})
const customerEmail = computed(() => {
  return customer.value?.email
})
const loadedCustomer = ref(null)
const loadedCustomerReady = ref(false)
watch(
  customerEmail,
  async (email) => {
    loadedCustomerReady.value = false
    loadedCustomer.value = null
    if (email) {
      try {
        loadedCustomer.value = await loadCustomerByEmail(email)
      } catch (error) {
        console.error('Failed to load customer for appointment card:', error)
      } finally {
        loadedCustomerReady.value = true
      }
    }
  },
  { immediate: true }
)
</script>

<style scoped>
.card {
  padding: 2px 6px;
  border-radius: 2px;
  font-size: 12px;
  white-space: nowrap;
  border-left: 2px solid white;
  cursor: pointer;

  &__title {
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
  }
}
</style>
